import { useEffect, useReducer } from 'react'
import { userRouter } from '../../../route'
import { history } from '../../../redux/store'
import { GET_SUPPLIER_BRAND_PAGE } from '../../../api/myBrand'
import { isResponseCodeSuccess } from '../../../tools/util'
import { CustomerConfirm } from '../../../components/ModalUser'
import { message } from 'antd'
import { POST_BRANDGIVEUP_API } from '../../../api/BrandApi'
import { useQuery } from '../../../tools/utilHooks'

type ActionType = 'setData' | 'setSearchData' | 'setLoading' | 'changePages'

interface Action {
  type: ActionType
  payload: any
}

interface LaunchbrandState {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
}

const initState: LaunchbrandState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100, loading: true },
  // 初始化搜索条件
  searchdata: {},
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}

const reducer = (state: LaunchbrandState, action: Action): LaunchbrandState => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setData':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoading':
      newstate.dataSource.loading = action.payload
      return newstate
    case 'setSearchData':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'changePages':
      newstate.pages = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

const setLoading = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

/**
 * 设置表格数据
 * @param param
 * @returns
 */
const setData = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}): Action => ({
  type: 'setData',
  payload: param,
})
// 搜索
const setSearchData = (param: any): Action => ({
  type: 'setSearchData',
  payload: param,
})
// 切换分页
const changePages = (param: { pageNo: number; pageSize?: number }): Action => ({
  type: 'changePages',
  payload: param,
})

export function useHook() {
  const supRoute = userRouter[1].url
  const [state, dispatch] = useReducer(reducer, initState)
  const { dataSource, pages } = state
  const query = useQuery()
  const status = query.get('status') || ''
  // 搜索
  const onSearch = (params: any) => {
    dispatch(setSearchData(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getdata(state)
  }

  // 切换分页
  const onChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      changePages({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 获取表格数据
  const getdata = async (state: LaunchbrandState) => {
    dispatch(setLoading(true))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_SUPPLIER_BRAND_PAGE({
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      brandCode: params.brandCode,
      brandNameCn: params.brandNameCn,
      brandNameEn: params.brandNameEn,
      manageType: params.manageType,
      mpmState: params.mpmState,
      tabType: '1',
      schemeId: params.schemeId,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setData({
          dataSource: { data: resdata, total: count, loading: false },
          pageNo: res.data.pageNo,
        }),
      )
      dispatch(setLoading(false))
    } else {
      dispatch(setLoading(false))
    }
  }

  const onJump = (val: any) => {
    let url = ''
    // 当前品牌状态为审核中则跳转至详情页只读
    if (val.mpmState === '1') {
      url = supRoute + '/brandDetail'
    } else {
      url = supRoute + '/editBrand'
    }
    history.replace({
      pathname: url,
      state: {
        BtnState: ['Edit'],
        brandId: val.brandId,
      },
    })
  }

  // 放弃
  const nopassSwitch = (id: string) => {
    const idArr = id
    CustomerConfirm({
      title: '提示',
      content: '确认放弃申请？',
      onOk: () => {
        givedata(String(idArr))
      },
    })
  }

  // 批量 放弃申请
  const givedata = async (assessId: string) => {
    message.loading('放弃中', 0)
    const resData = await POST_BRANDGIVEUP_API({ brandId: assessId })
    if (resData.code === 0) {
      message.success('已放弃')
      getdata(state)
    } else {
      message.destroy()
    }
  }
  useEffect(() => {
    if (status === 'reject') {
      getdata({ ...state, ...{ searchdata: { mpmState: '2' } } })
    } else {
      getdata(state)
    }
    // eslint-disable-next-line
  }, [status])

  return {
    dataSource,
    pages,
    onJump,
    onSearch,
    onRefresh,
    onChange,
    nopassSwitch,
  }
}
import { useEffect, useReducer } from 'react'
import { userRouter } from '../../../route'
import { history } from '../../../redux/store'
import { GET_SUPPLIER_BRAND_PAGE } from '../../../api/myBrand'
import { isResponseCodeSuccess } from '../../../tools/util'
import { CustomerConfirm } from '../../../components/ModalUser'
import { message } from 'antd'
import { POST_BRANDGIVEUP_API } from '../../../api/BrandApi'
import { useQuery } from '../../../tools/utilHooks'

type ActionType = 'setData' | 'setSearchData' | 'setLoading' | 'changePages'

interface Action {
  type: ActionType
  payload: any
}

interface LaunchbrandState {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
}

const initState: LaunchbrandState = {
  // 表格数据 总条数
  dataSource: { data: [], total: 100, loading: true },
  // 初始化搜索条件
  searchdata: {},
  // 初始化分页
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}

const reducer = (state: LaunchbrandState, action: Action): LaunchbrandState => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setData':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setLoading':
      newstate.dataSource.loading = action.payload
      return newstate
    case 'setSearchData':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'changePages':
      newstate.pages = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

const setLoading = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

/**
 * 设置表格数据
 * @param param
 * @returns
 */
const setData = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}): Action => ({
  type: 'setData',
  payload: param,
})
// 搜索
const setSearchData = (param: any): Action => ({
  type: 'setSearchData',
  payload: param,
})
// 切换分页
const changePages = (param: { pageNo: number; pageSize?: number }): Action => ({
  type: 'changePages',
  payload: param,
})

export function useHook() {
  const supRoute = userRouter[1].url
  const [state, dispatch] = useReducer(reducer, initState)
  const { dataSource, pages } = state
  const query = useQuery()
  const status = query.get('status') || ''
  // 搜索
  const onSearch = (params: any) => {
    dispatch(setSearchData(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const onRefresh = () => {
    getdata(state)
  }

  // 切换分页
  const onChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      changePages({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 获取表格数据
  const getdata = async (state: LaunchbrandState) => {
    dispatch(setLoading(true))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_SUPPLIER_BRAND_PAGE({
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      brandCode: params.brandCode,
      brandNameCn: params.brandNameCn,
      brandNameEn: params.brandNameEn,
      manageType: params.manageType,
      mpmState: params.mpmState,
      tabType: '1',
      schemeId: params.schemeId,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setData({
          dataSource: { data: resdata, total: count, loading: false },
          pageNo: res.data.pageNo,
        }),
      )
      dispatch(setLoading(false))
    } else {
      dispatch(setLoading(false))
    }
  }

  const onJump = (val: any) => {
    let url = ''
    // 当前品牌状态为审核中则跳转至详情页只读
    if (val.mpmState === '1') {
      url = supRoute + '/brandDetail'
    } else {
      url = supRoute + '/editBrand'
    }
    history.replace({
      pathname: url,
      state: {
        BtnState: ['Edit'],
        brandId: val.brandId,
      },
    })
  }

  // 放弃
  const nopassSwitch = (id: string) => {
    const idArr = id
    CustomerConfirm({
      title: '提示',
      content: '确认放弃申请？',
      onOk: () => {
        givedata(String(idArr))
      },
    })
  }

  // 批量 放弃申请
  const givedata = async (assessId: string) => {
    message.loading('放弃中', 0)
    const resData = await POST_BRANDGIVEUP_API({ brandId: assessId })
    if (resData.code === 0) {
      message.success('已放弃')
      getdata(state)
    } else {
      message.destroy()
    }
  }
  useEffect(() => {
    if (status === 'reject') {
      getdata({ ...state, ...{ searchdata: { mpmState: '2' } } })
    } else {
      getdata(state)
    }
    // eslint-disable-next-line
  }, [status])

  return {
    dataSource,
    pages,
    onJump,
    onSearch,
    onRefresh,
    onChange,
    nopassSwitch,
  }
}
